import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {TeamWrapper} from "../models/team.model";
import {catchError, of} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AppService {
  baseUrl = 'https://app.dart-rock-cafe.de/';

  constructor(private http: HttpClient) { }

  resetPassword(token: string, userId: string, password: string) {
    return this.http.post(this.baseUrl + "auth/reset-password/" + userId + "/" + token, {"password": password});
  }

  verify(token: string, userId: string) {
    return this.http.get(this.baseUrl + "auth/verify/" + userId + "/" + token, {})
  }

  getTeams() {
    return this.http.get<TeamWrapper>(this.baseUrl + "teams/team", {}).pipe(
      catchError((error) => {
        console.error('Teams API konnte nicht geladen werden:', error);
        return of({data: [], message: 'Teams API nicht erreichbar', success: false});
      })
    )
  }
}
